export default "__VITE_ASSET__DvNHxtfk__"